module.exports = __webpack_public_path__ + "img/PS35.4f6f4afd.png";